import { SelectOption } from '@vchasno/ui-kit';

import { t } from 'ttag';

import { ActionExecutorType } from 'api/api';

const DYNAMIC_EXECUTOR_TYPE_MAP: Record<ActionExecutorType, string> = {
  [ActionExecutorType.Initiator]: t`Співробітник, ініціатор задачі`,
  [ActionExecutorType.EmployeeLeader]: t`Адміністративний керівник`,
  [ActionExecutorType.CompanyLeader]: t`Керівник підприємства`,
  [ActionExecutorType.EmployeeManagerialLeader]: t`Управлінський керівник`,
  [ActionExecutorType.Static]: t`Співробітник`,
};

export const localizeDynamicExecutorType = (type: ActionExecutorType) => {
  if (type in DYNAMIC_EXECUTOR_TYPE_MAP) {
    return DYNAMIC_EXECUTOR_TYPE_MAP[type];
  }

  throw new Error(`Unknown dynamic executor type: ${type}`);
};

class ActionExecutorOption implements SelectOption {
  readonly value: string;
  readonly label: string;

  constructor(type: ActionExecutorType) {
    this.value = type;
    this.label = localizeDynamicExecutorType(type);
  }
}

interface DynamicExecutorOption extends SelectOption {
  value: ActionExecutorType;
}

export const EXTRA_ACTION_OPTIONS: SelectOption[] = [
  new ActionExecutorOption(ActionExecutorType.Initiator),
  new ActionExecutorOption(ActionExecutorType.EmployeeLeader),
  new ActionExecutorOption(ActionExecutorType.EmployeeManagerialLeader),
  new ActionExecutorOption(ActionExecutorType.CompanyLeader),
];

const DYNAMIC_EXECUTOR_TYPES: unknown[] = [
  ActionExecutorType.CompanyLeader,
  ActionExecutorType.EmployeeLeader,
  ActionExecutorType.Initiator,
  ActionExecutorType.EmployeeManagerialLeader,
];

export const isDynamicExecutor = (
  value: unknown,
): value is DynamicExecutorOption => DYNAMIC_EXECUTOR_TYPES.includes(value);

export const isDynamicExecutorOption = (
  option: SelectOption,
): option is DynamicExecutorOption => isDynamicExecutor(option.value);
